import { Select, type SelectProps } from "@mantine/core";
import { type FC, useMemo } from "react";

import { api } from "@/api.ts";
import { useSuspenseQueryPostgrest } from "@/hooks/useSuspenseQueryPostgrest.ts";

export const ProjectSelect: FC<
  Omit<SelectProps, "searchable" | "data" | "value" | "onChange"> & {
    value?: number | null;
    onChange?: (value: number | null) => void;
  }
> = ({ limit, value, onChange, ...rest }) => {
  const { data } = useSuspenseQueryPostgrest(api.from("project").select("*"));
  const options = useMemo(
    () =>
      data.map((project) => ({
        value: project.id.toString(),
        label: `${project.identifier} (${project.name})`,
      })),
    [data],
  );

  return (
    <Select
      limit={limit ?? 5}
      data={options}
      searchable
      value={typeof value === "number" ? String(value) : value}
      onChange={(val) =>
        onChange?.(typeof val === "string" ? Number(val) : null)
      }
      {...rest}
    />
  );
};
